import { css, useScrollLock, useTranslation } from '@obvio/app'
import { SvgCloseMenu } from '@obvio/svg'

import {
  Position,
  ExitButton,
  StyledSection,
  InfoText,
} from './Overlay/components'

import type { ReactElement } from 'react'

const sectionOuterCss = css`
  min-height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
`

type OverlayProps = {
  children: ReactElement
  close(): void
}

export function Overlay({ children, close }: OverlayProps): ReactElement {
  const { t } = useTranslation()
  const ref = useScrollLock()

  return (
    <Position ref={ref}>
      <ExitButton kind={['icon', 'transparent']} onClick={close}>
        <SvgCloseMenu />
      </ExitButton>
      <StyledSection outerCss={sectionOuterCss}>
        <div>{children}</div>
        <InfoText>{t('event.contact')}</InfoText>
      </StyledSection>
    </Position>
  )
}
